/** Wallet transactions API (read-only — no create/update/delete by design). */

import { apiGet, type PaginatedResponse, type QueryParams } from "@/lib/api-client";
import type { ApiWalletTransaction } from "./wallet-transactions.adapter";

export interface WalletTransactionsListParams {
  page?: number;
  limit?: number;
  search?: string;
  walletId?: string;
  type?: string;
  source?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export const walletTransactionsApi = {
  list: (params: WalletTransactionsListParams = {}) =>
    apiGet<PaginatedResponse<ApiWalletTransaction>>("/wallet-transactions", params as QueryParams),
  listByWallet: (walletId: string, params: WalletTransactionsListParams = {}) =>
    apiGet<PaginatedResponse<ApiWalletTransaction>>(`/wallets/${walletId}/transactions`, params as QueryParams),
};
